import { DICE_COUNT, MAX_ROLLS, type HandState, type ScoredHand } from './types';
import { rollDie, type Rng } from './rng';
import { scoreHand } from './combos';

/** Lancio iniziale: 6 dadi, nessuno tenuto. */
export function rollHand(rng: Rng): HandState {
  return {
    faces: Array.from({ length: DICE_COUNT }, () => rollDie(rng)),
    held: Array.from({ length: DICE_COUNT }, () => false),
    rollsUsed: 1,
    closed: false,
  };
}

export function canReroll(state: HandState): boolean {
  return !state.closed && state.rollsUsed < MAX_ROLLS && state.held.some((h) => !h);
}

export function rerollsLeft(state: HandState): number {
  return Math.max(0, MAX_ROLLS - state.rollsUsed);
}

export function toggleHold(state: HandState, index: number): HandState {
  if (state.closed || index < 0 || index >= state.held.length) return state;
  const held = state.held.slice();
  held[index] = !held[index];
  return { ...state, held };
}

/** Rilancia i dadi non tenuti. I dadi tenuti NON consumano rng: il replay resta stabile. */
export function reroll(state: HandState, rng: Rng): HandState {
  if (!canReroll(state)) return state;
  const faces = state.faces.map((f, i) => (state.held[i] ? f : rollDie(rng)));
  return { ...state, faces, rollsUsed: state.rollsUsed + 1 };
}

/** Chiude la mano e calcola la combo migliore su TUTTI i dadi sul tavolo. */
export function closeHand(state: HandState): { state: HandState; result: ScoredHand } {
  return { state: { ...state, closed: true }, result: scoreHand(state.faces) };
}
